var map = {
	"./baac.svg": "795a",
	"./bay.svg": "6bb9",
	"./bbl.svg": "2a14",
	"./bnp.svg": "b5e9",
	"./boa.svg": "6c00",
	"./cacib.svg": "6448",
	"./cimb.svg": "cea8",
	"./citi.svg": "9bd2",
	"./db.svg": "b7b6",
	"./ghb.svg": "e518",
	"./gsb.svg": "53c4",
	"./hsbc.svg": "589c",
	"./ibank.svg": "098d",
	"./icbc.svg": "13a1",
	"./jpm.svg": "f3f1",
	"./kbank.svg": "62c8",
	"./kkp.svg": "039c",
	"./ktb.svg": "d192",
	"./lhb.svg": "126e",
	"./mb.svg": "ff5a",
	"./mega.svg": "da9a",
	"./mufg.svg": "0a47",
	"./rbs.svg": "60ec",
	"./sc.svg": "4a94",
	"./scb.svg": "65e2",
	"./smbc.svg": "55c2",
	"./tcap.svg": "44b2",
	"./tcrb.svg": "8d1a",
	"./tisco.svg": "fec1",
	"./tmb.svg": "f84c",
	"./ttb.svg": "359b",
	"./ttb_.svg": "6007",
	"./uob.svg": "0bfe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "700a";